export const MAX_SIGNIFICANT_DIGITS = 11;
